import React from 'react';

interface SettingsSectionProps {
  title: string;
  children: React.ReactNode;
  readOnly?: boolean;
  /** Hide the horizontal rule under the section title */
  hideRule?: boolean;
}

export const SettingsSection: React.FC<SettingsSectionProps> = ({ title, children, readOnly, hideRule }) => (
  <section className="mb-4 sm:mb-5 min-w-0">
    <h3 className="text-sm font-semibold vscode-text-primary mb-0.5">{title}</h3>
    {!hideRule && <div className="border-b border-[var(--vscode-border)] border-solid mb-3" style={{ borderBottomWidth: 2 }} />}
    {readOnly && (
      <p className="text-xs vscode-text-tertiary mb-1.5">Read-only</p>
    )}
    {children}
  </section>
);

export default SettingsSection;
